import Vue from "vue";
import Vuex from 'vuex'
import Router from "vue-router";
Vue.config.devtools = true;
Vue.use(Router);

let a = "";
let router = new Router({
    mode: "history",
    base: "",
    routes: [{
        // 登录页
        path: "/",
        name: "Login",
        component: () => import("./views/Login"),
        },{
            // 登录页
            path: "/login",
            name: "Login",
            component: () => import("./views/Login"),
        },{
            // 登录页
          path: "/Login/index",
          name: "Login1",
          component: () => import("./views/Login/index"),
        },{
            path: "/testPage",
            name: "Login1",
            component: () => import("./views/TestPage/TestPage"),
        },{
            path: "/home",
            name: "home",
            component: () => import("./components/Home.vue"),
            children: [{
                    path: "/home/dashboard",
                    name: "dashboard",
                    component: () => import("./views/Dashboard.vue"),
                }, {
                    path: "/system/staffManager",
                    name: "staffManager",
                    component: () => import("./views/Staff/Staff.vue"),
                }, {
                    path: "/system/roleManager",
                    name: "roleManager",
                    component: () => import("./views/Role/Role.vue"),
                }, {
                    path: "/system/organization",
                    name: "organization",
                    component: () => import("./views/Organization/Organization.vue"),
                }, {
                    path: "/system/permission",
                    name: "permission",
                    component: () => import("./views/Permission/Permission.vue"),
                }, {
                    path: "/mall/teacher",
                    name: "teacher",
                    component: () => import("./views/Teacher/Teacher.vue"),
                }, {
                    path: "/system/recommendTeacher",
                    name: "recommendTeacher",
                    component: () => import("./views/Teacher/RecommendTeacher.vue"),
                }, {
                    path: "/system/teacherDetail",
                    name: "teacherDetail",
                    component: () => import("./views/Teacher/Detail.vue"),
                }, {
                    path: "/system/userOrg",
                    name: "userOrg",
                    component: () => import("./views/UserOrg/UserOrg.vue"),
                }, {
                    path: "/system/log",
                    name: "log",
                    component: () => import("./views/Log/Log.vue"),
                },{
                    path: "/system/click",
                    name: "click",
                    component: () => import("./views/Log/click.vue"),
                }, {
                    path: "/system/robotclick",
                    name: "robotClick",
                    component: () => import("./views/Log/robotClick.vue"),
                }, {
                    path: "/system/searchWord",
                    name: "searchWord",
                    component: () => import("./views/Log/searchWord.vue"),
                }, {
                    path: "/mall/commodity",
                    name: "commodity",
                    component: () => import("./views/Commodity/Commodity.vue"),
                }, {
                    path: "/mall/addCommodity",
                    name: "addCommodity",
                    component: () => import("./views/Commodity/add.vue"),
                }, {
                     path: "/mall/addCommodity1",
                     name: "addCommodity1",
                    component: () => import("./views/Commodity/addCommodity.vue"),
                }, {
                    path: "/mall/commodityPackage",
                    name: "commodityPackage",
                    component: () => import("./views/Commodity/CommodityPackage.vue"),
                }, {
                    path: "/mall/addCommodityPackage",
                    name: "addCommodityPackage",
                    component: () => import("./views/Commodity/addPackage.vue"),
                }, {
                    path: "/mall/liveCommodity",
                    name: "liveCommodity",
                    component: () => import("./views/Commodity/LiveCommodity.vue"),
                }, {
                    path: "/mall/auditionCommodity",
                    name: "auditionCommodity",
                    component: () => import("./views/Commodity/AuditionCommodity.vue"),
                }, {
                    path: "/mall/courseCategory",
                    name: "courseCategory",
                    component: () => import("./views/CourseCategory/CourseCategory.vue"),
                }, {
                    path: "/mall/courseCategoryDrag",
                    name: "courseCategoryDrag",
                    component: () => import("./views/CourseCategory/CourseCategoryDrag.vue"),
                }, {
                    path: "/mall/order",
                    name: "order",
                    component: () => import("./views/Order/Order.vue"),
                }, {
                      path: "/mall/orderyh",
                      name: "ordyher",
                      component: () => import("./views/OrderYh/Order.vue"),
                }, {
                      path: "/mall/agents",
                      name: "proxy",
                      component: () => import("./views/OrderYh/Agents.vue"),
                }, {
                    path: "/mall/orderDetail",
                    name: "orderDetail",
                    component: () => import("./views/Order/OrderDetail.vue"),
                }, {
                  path: "/mall/orderyhDetail",
                  name: "orderyhDetail",
                  component: () => import("./views/OrderYh/OrderDetail.vue"),
                },  {
                    path: "/mall/posPay",
                    name: "posPay",
                    component: () => import("./views/Order/POS.vue"),
                }, {
                    path: "/mall/courseReviewList",
                    name: "courseReviewList",
                    component: () => import("./views/CourseReview/CourseReviewList.vue"),
                }, {
                    path: "/mall/courseReview",
                    name: "courseReview",
                    component: () => import("./views/CourseReview/CourseReview.vue"),
                }, {
                    path: "/mall/courseReviewDetail",
                    name: "courseReviewDetail",
                    component: () => import("./views/CourseReview/detail.vue"),
                }, {
                    path: "/mall/comment",
                    name: "comment",
                    component: () => import("./views/Comment/Comment.vue"),
                }, {
                    path: "/mall/welfare",
                    name: "welfare",
                    component: () => import("./views/Welfare/Welfare.vue"),
                }, {
                    path: "/mall/addWelfare",
                    name: "addWelfare",
                    component: () => import("./views/Welfare/Add.vue"),
                },{
                    path: "/message/messageCategory",
                    name: "messageCategory",
                    component: () => import("./views/Message/MessageCategory.vue"),
                }, {
                    path: "/message/message",
                    name: "message",
                    component: () => import("./views/Message/Message.vue"),
                }, {
                    path: "/message/addMessage",
                    name: "addMessage",
                    component: () => import("./views/Message/AddMessage.vue"),
                }, {
                    path: "/news/newsCategory",
                    name: "newsCategory",
                    component: () => import("./views/News/NewsCategory.vue"),
                }, {
                    path: "/news/news",
                    name: "news",
                    component: () => import("./views/News/News.vue"),
                }, {
                    path: "/news/addnews",
                    name: "addnews",
                    component: () => import("./views/News/AddNews.vue"),
                },{
                    path: "/resources/resourcesCategory",
                    name: "resourcesCategory",
                    component: () => import("./views/Resources/ResourcesCategory.vue"),
                }, {
                    path: "/resources/resources",
                    name: "resources",
                    component: () => import("./views/Resources/Resources.vue"),
                }, {
                    path: "/resources/addresources",
                    name: "addresources",
                    component: () => import("./views/Resources/AddResources.vue"),
                },{
                    path: "/resources/resourcest",
                    name: "resourcest",
                    component: () => import("./views/Resources/Resourcest.vue"),
                },{
                    path: "/resources/resourcesd",
                    name: "resourcesd",
                    component: () => import("./views/Resources/Resourcesd.vue"),
                },{
                    path: "/resources/resourcesa",
                    name: "resourcesa",
                    component: () => import("./views/Resources/Resourcesa.vue"),
                },{
                    path: "/resources/addresourcesa",
                    name: "addresourcesa",
                    component: () => import("./views/Resources/AddResourcesa.vue"),
                },{
                    path: "/resources/addresourcesd",
                    name: "addresourcesd",
                    component: () => import("./views/Resources/AddResourcesd.vue"),
                },{
                    path: "/resources/addresourcest",
                    name: "addresourcest",
                    component: () => import("./views/Resources/AddResourcest.vue"),
                },{
                    path: "/system/Student/StudentManager",
                    name: "studentManager",
                    component: () => import("./views/Student/StudentManager.vue"),
                }, {
                    path: "/system/Student/agentStudentManager",
                    name: "agentStudentManager",
                    component: () => import("./views/Student/AgentStudentManager.vue"),
                },{
                    path: "/system/Student/StudentImport",
                    name: "studentImport",
                    component: () => import("./views/Student/StudentImport.vue"),
                 },{
                    path: "/system/StudentCourse/StudentCourse",
                    name: "studentCourse",
                    component: () => import("./views/StudentCourse/StudentCourse.vue"),
                }, {
                    path: "/StudentCourse/AllocateCourse",
                    name: "allocateCourse",
                    component: () => import("./views/StudentCourse/AllocateCourse.vue"),
                }, {
                    path: "/StudentCourse/ModifyCourse",
                    name: "modifyCourse",
                    component: () => import("./views/StudentCourse/ModifyCourse.vue"),
                },{
                    path: "/system/live",
                    name: "live",
                    component: () => import("./views/Live/Live.vue"),
                }, {
                    path: "/drap/draplist",
                    name: "draplist",
                    component: () => import("./views/drap/dnd-list.vue"),
                }, {
                      path: "/v2/player",
                      name: "player",
                      component: () => import("./views/v2/Player.vue"),
                }, {
                      path: "/mall/banner/indexBanner",
                      name: "banner",
                      component: () => import("./views/Banner/banner.vue"),
                }, {
                  path: "/system/reserve/studentReserve",
                  name: "reserve",
                  component: () => import("./views/Reserve/Reserve.vue"),
                }, {
                  path: "/system/reserve/reserveManager",
                  name: "reserveManager",
                  component: () => import("./views/Reserve/ReserveManager.vue"),
                },
                {
                    path: "/teaching/teaching",
                    name: "loteachingg",
                    component: () => import("./views/Teaching/Teaching.vue"),
                },
                {
                    path: "/teaching/addteachTree",
                    name: "addteachTree",
                    component: () => import("./views/Teaching/addteachTree.vue"),
                },
                {
                    path: "/testimonial/testimonial",
                    name: "testimonial",
                    component: () => import("./views/Testimonial/Testimonial.vue"),
                },
                {
                    path: "/testimonial/addtestimonial",
                    name: "addtestimonial",
                    component: () => import("./views/Testimonial/addTestimonial.vue"),
                },
                {
                    path: "/openclass/openclass",
                    name: "openclass",
                    component: () => import("./views/openclass/Openclass.vue"),
                },
                {
                    path: "/openclass/addopenclass",
                    name: "addopenclass",
                    component: () => import("./views/openclass/addOpenclass.vue"),
                },
                {
                    path: "/blog/addblog",
                    name: "addblog",
                    component: () => import("./views/blog/addBlog.vue"),
                },
                {
                    path: "/blog/addblogcategory",
                    name: "addblogcategory",
                    component: () => import("./views/blog/addBlogCategory.vue"),
                },
                {
                    path: "/blog/blog",
                    name: "blog",
                    component: () => import("./views/blog/Blog.vue"),
                },
                {
                    path: "/blog/blogcategory",
                    name: "blogcategory",
                    component: () => import("./views/blog/BlogCategory.vue"),
                },
                {
                    path: "/blog/subscribe",
                    name: "subscribe",
                    component: () => import("./views/blog/BlogSubscribe.vue"),
                },
                {
                    path: "/blog/blogcommentlist",
                    name: "blogcommentlist",
                    component: () => import("./views/blog/blogCommentList.vue"),
                },
                {
                    path: "/message/MessageStudentList",
                    name: "MessageStudentList",
                    component: () => import("./views/Message/MessageStudentList.vue"),
                },
                {
                    path: "/system/dict",
                    name: "DictList",
                    component: () => import("./views/dict/dictTypeList.vue"),
                },
                {
                    path: "/system/dictData",
                    name: "DictDataList",
                    component: () => import("./views/dict/data.vue"),
                },
            ],
        },
    ],
});
export default router;